
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.97 40.98a1 1 0 01-.7-.29L19.13 30.56a1 1 0 010-1.41 1 1 0 011.41 0l8.43 8.43V14a1 1 0 012 0v23.56l8.44-8.44a1 1 0 111.41 1.42L30.71 40.65a.999.999 0 01-.74.33zM11 45.57h38a1 1 0 110 2H11a1 1 0 010-2z"}})])
          )
        }
      }
    